import styled from 'styled-components'
import { GREY_DARK, GREY_LIGHTS } from '../../utils/colors'

export const Container = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 35px;

  .exam_name {
    margin-right: 25px;
    flex: 1;
    overflow: hidden;
    font-size: 16px;
    line-height: 1.63;
    color: ${GREY_LIGHTS};

    .exam_name_label {
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 7px;
      font-size: 18px;
      line-height: 1.44;
      color: ${GREY_DARK};
    }
  }

  .exam_result, .exam_unit {
    width: 141px;
    height: 62px;
  }

  .exam_unit {
    label {
      max-width: 60%;
    }
  }

  .exam_result {
    margin-right: 25px;

    input {
      height: 60px;
      padding-left: 17px;
    }
  }

  label {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    top: 26px;
    left: 17px;
  }
`
